import { MUSCLE_LABEL, type MuscleSlug } from "@heraion/shared";

import type { TFn } from "../i18nTypes";

/** A bodymap slug's name, localized (EN fallback). abs and obliques both read
 *  "Core" on purpose: PainVolumePanel merges them by this label. `splitCore`
 *  names the obliques apart, for a list that shows both. */
export const muscleLabel = (
  t: TFn,
  slug: MuscleSlug,
  opts?: { splitCore?: boolean },
): string =>
  opts?.splitCore && slug === "obliques"
    ? t("muscle.obliques")
    : t(`mobile.bodymap.muscle.${slug}`, { defaultValue: MUSCLE_LABEL[slug] ?? slug });
